var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccessibilityButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "44.000000pt",
    height: "44.000000pt",
    viewBox: "0 0 44.000000 44.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,44.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185 435 c-5 -2 -23 -6 -38 -9 -46 -11 -114 -81 -132 -137 -18 -52 -14 -122 7 -164 41 -79 141 -133 226 -120 59 9 78 18 124 63 66 63 84 173 43 252 -41 77 -162 138 -230 115z m60 -115 c0 -18 -6 -26 -23 -28 -13 -2 -25 3 -28 12 -10 26 4 48 28 44 17 -2 23 -10 23 -28z m85 -63 c0 -7 -16 -21 -35 -30 l-34 -16 14 -47 c8 -26 12 -51 9 -56 -10 -16 -31 -8 -44 17 -7 14 -16 25 -20 25 -4 0 -13 -11 -20 -25 -13 -25 -34 -33 -44 -17 -3 5 1 30 9 56 l14 47 -34 16 c-66 31 -45 43 75 43 84 0 110 -3 110 -13z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibilityButton);
export default __webpack_public_path__ + "static/media/accessibility-button.7a3b39b7.svg";
export { ForwardRef as ReactComponent };